let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7B6Sc")).then(() => parcelRequire('4iDjt'));